import { getProvidersByFilter, searchAllProviders } from "@/utils/http";
import { useMutation } from "@tanstack/react-query";
import { forwardRef, useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import FormControl from "../checks_and_radios/form_control";
import { ProviderListElements } from "@/components/events/provider_selector";
import TextInput from "../inputs/text_input";
import location_classes from "../../events/select_location.module.css";

const CustomProviderToggle = forwardRef(function CustomProviderToggle({ onClick, value, setValue, isOpen, onBlur, onFocus, title, placeholder }, ref) {

    return (
        <div ref={ref} onClick={(e) => {e.preventDefault(); onClick(e);}}>
            <TextInput
                className={`w-100 pointer`}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onBlur={onBlur}
                onFocus={onFocus}
                type={"text"}
                label={title ? title : "Szolgáltató"}
                placeholder={placeholder ? placeholder : "Helyszín neve"}
            />
        </div>
    )
});

export default function ProviderDropdownPublic({starting_values, starting_name, providerId, setProviderId, wedding_id, has_switch = true, title, placeholder, onSelect, setProviderName, searchIn = "helyszinek"}) {
    const [isOpen, setIsOpen] = useState(false);
    const [inputIsActive, setInputIsActive] = useState(false);
    const [providerSearch, setProviderSearch] = useState(starting_name ? starting_name : "");
    const [previousSearch, setPreviousSearch] = useState(starting_name ? starting_name : "");
    const [selectedProvider, setSelectedProvider] = useState(providerId ? providerId : 0);
    const [filteredProviderList, setFilteredProviderList] = useState(undefined);
    const restoredRef = useRef(false);

    // Szinkronizálás ha starting_name külsőleg változik üresből (pl. localStorage visszatöltés) — csak egyszer fut
    useEffect(() => {
        if (!restoredRef.current && starting_name) {
            setProviderSearch(starting_name);
            setPreviousSearch(starting_name);
            restoredRef.current = true;
        }
    }, [starting_name]);

    const handleIsOpen = () => {
        if(!inputIsActive || !isOpen) {
            setIsOpen(!isOpen);
        }
    }

    useEffect(() => {
        if(!isOpen && selectedProvider === 0 && providerId !== 0) {
            setSelectedProvider(providerId);
            setProviderSearch(previousSearch);
        }
    }, [isOpen])

    const switchChangeHandler = () => {
        if(providerId === 0) setProviderId(selectedProvider);
        else {
            setProviderId(0);
            setSelectedProvider(0);
            setProviderSearch("");
        }
    }
    
    const { mutate: searchProvider } = useMutation({
        mutationFn: getProvidersByFilter,
        onSuccess: (response, params) => {
            if(response.success) {
                if(providerSearch === params.sent_search) setFilteredProviderList({favourites: [], providers: response.response.providers});
            } else setFilteredProviderList({favourites: [], providers: []});
        }
    });

    const providerSelectHandler = (provider) => {
        if(onSelect) {
            onSelect(provider);
            return;
        }

        setSelectedProvider(provider.id);
        setProviderId(provider.id);

        setProviderSearch(provider.name);
        setPreviousSearch(provider.name);
        if (setProviderName) setProviderName(provider.name);
    }

    const handleProviderSearch = (val) => {
        setProviderSearch(val);
        setSelectedProvider(0);
        setProviderId(0);
        if (setProviderName) setProviderName(val);
    }

    useEffect(() => {
        searchProvider({pager: true, params: {"filter[type_id]": searchIn, "filter[name]": (providerSearch ? `*${providerSearch}*` : undefined)}, sent_search: providerSearch});
    }, [providerSearch])

    return <>
        <Dropdown drop="up" show={isOpen} onToggle={handleIsOpen} style={{width: "100%"}}>
            <Dropdown.Toggle as={CustomProviderToggle} value={providerSearch} setValue={handleProviderSearch} isOpen={isOpen} setIsOpen={setIsOpen} onBlur={() => setInputIsActive(false)} onFocus={() => { setInputIsActive(true); setIsOpen(true); }} title={title} placeholder={placeholder} />
            <Dropdown.Menu className={`${location_classes["dropdown_menu"]} overflow-auto`} style={{width: "100%", maxHeight: 300}}>
                {(filteredProviderList)
                    ? <ProviderListElements favourites={filteredProviderList.favourites} providers={filteredProviderList.providers} providerSelectHandler={providerSelectHandler} hide_when_empty search_val={providerSearch} hide_search_empty={true} has_title={false} />
                    : <ProviderListElements favourites={starting_values.favourites} providers={starting_values.default_providers} providerSelectHandler={providerSelectHandler} hide_when_empty search_val={providerSearch} hide_search_empty={true} has_title={false} />
                }
            </Dropdown.Menu>
        </Dropdown>
        {has_switch && <FormControl id={`location-selection`} className="align-items-center" type="switch" size="sm" checked={providerId === 0} onChange={switchChangeHandler} main_text={"Még nincs kiválasztott helyszín"} />}
    </>
}